module.exports = __webpack_public_path__ + "img/arrow-left-circle.d14a0484.svg";